import { createSelector } from 'reselect';
import { RootState } from 'src/redux/store';

const selectLastRoutes = (state: RootState) => state.lastRoute;

const selectLastRoute = createSelector(
  selectLastRoutes,
  (state) => state.lastRoute?.last_path
);

const selectLastUser = createSelector(
  selectLastRoutes,
  (state) => state.lastRoute?.id
);

export const selectors = {
  selectLastRoute,
  selectLastUser
};
